module.exports = __webpack_public_path__ + "img/corndog.c1cb516c.png";